import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ServerContext = createContext(null);

export function ServerContextProvider({ context, children }) {
	return <ServerContext.Provider value={context}>{children}</ServerContext.Provider>;
}

ServerContextProvider.propTypes = {
	context: PropTypes.object,
	children: PropTypes.node,
};

export function useServerContext() {
	return useContext(ServerContext);
}

export default ServerContext;
